import { useNavigate, useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'
import { usePostSiteVerifyEmailMutation } from '../../app/api'
import { showAlert } from '../../app/store/reducers/AppSlice'
import { useAppDispatch } from '../../app/store/hooks/Redux'

export const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const [verify] = usePostSiteVerifyEmailMutation()

  useEffect(() => {
    if (searchParams.has('token')) {
      verify({ token: searchParams.get('token') as string }).then((result) => {
        navigate('/')

        const response = result as { data?: { success?: boolean; data?: { token?: string } } }

        if (response?.data?.success) {
          dispatch(
            showAlert({
              message: response.data?.data?.token ?? '',
              timeout: 10000,
              type: 'success',
            }),
          )
        }
      })
    } else {
      navigate('/')
    }
  }, [searchParams])

  return null
}
